<template>
    <div id="job" class="content">
        <b-container id="main" class="section">
            <b-row align-v="start">
                <b-col cols="12" lg="9">
                    <div class="subsection">
                        <div class="view">
                            <!-- eslint-disable-next-line vue/no-v-html -->
                            <div class="html" v-html="jobDescription" />

                            <iframe
                                id="answer"
                                :src="$store.state.jobs.job.answer_form_iframe_url"
                                :style="'height: ' + iframeHeight + 'px'"
                                class="answer-form-iframe"
                            >
                            </iframe>
                        </div>
                    </div>
                </b-col>

                <b-col cols="12" lg="3">
                    <div class="subsection">
                        <div class="view d-flex flex-column">
                            <b-img :fluid="true" :src="$store.state.jobs.job.company.logo" class="section_image" />

                            <hr class="section_line" />

                            <h4 class="section_title">
                                {{ $store.state.jobs.job.company.name }}
                            </h4>

                            <b-nav id="informations_list">
                                <b-nav-text v-if="$store.state.jobs.job.addresses">
                                    <span> {{ $t("jobs.detail.info.address") }}: </span>
                                    {{ $store.state.jobs.job.addresses.join(' | ') }}
                                </b-nav-text>

                                <b-nav-text v-if="$store.state.jobs.job.education">
                                    <span> {{ $t("jobs.detail.info.education") }}: </span>
                                    {{ $store.state.jobs.job.education.name }}
                                </b-nav-text>

                                <b-nav-text v-if="$store.state.jobs.job.workfields.length > 0">
                                    <span> {{ $t("jobs.detail.info.workfields") }}: </span>
                                    {{ $store.state.jobs.job.workfields.map(w => w.name).join(' | ') }}
                                </b-nav-text>

                                <b-nav-text v-if="$store.state.jobs.job.employment">
                                    <span> {{ $t("jobs.detail.info.employment") }}: </span>
                                    {{ $store.state.jobs.job.employment.name }}
                                </b-nav-text>

                                <b-nav-text v-if="$store.state.jobs.job.salary">
                                    <span> {{ $t("jobs.detail.info.salary") }}: </span>
                                    {{ $store.state.jobs.job.salary }}
                                </b-nav-text>
                            </b-nav>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>

        <SimilarJobs />
    </div>
</template>

<script>
import { sanitize } from "isomorphic-dompurify"
import SimilarJobs from "~/components/SimilarJobs";

export default {
    components: {
        SimilarJobs,
    },
    layout: "with_job_title",
    async asyncData({ store, params, error }) {
        try {
            return await store.dispatch("jobs/readJob", {
                id: params.id,
            });
        } catch (e) {
            if (e.response?.status === 404) {
                return error({ statusCode: 404, message: `Job ID "${params.id}" not found` });
            }

            throw e;
        }
    },
    data() {
        return {
            iframeHeight: 600,
        };
    },
    head() {
        return {
            title: this.$store.state.jobs.job.title,
            link: [
                {
                    rel: 'canonical',
                    href: this.$store.state.jobs.job.meta_tags.canonical,
                },
            ],
        };
    },
    computed: {
        jobDescription() {
            return sanitize(this.$store.state.jobs.job.description, {
                ALLOWED_TAGS: ["br", "a", "p", "img", "h1", "h2", "h3", "h4", "ul", "ol", "li", "strong", "i"],
            });
        },
    },
    mounted() {
        window.addEventListener(
            "message",
            e => {
                if (e.data?.type === "resize") {
                    this.iframeHeight = e.data.height;
                }
            },
            false,
        );
    },
};
</script>
<style lang="css" scoped>
.answer-form-iframe {
    width: 100%;
    border: 0;
}
</style>
